// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from cc-std.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CcStdIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.985 0c2.238 0 4.143.781 5.715 2.343a7.694 7.694 0 0 1 1.714 2.579C15.804 5.888 16 6.914 16 8a8.164 8.164 0 0 1-.579 3.078 7.344 7.344 0 0 1-1.707 2.536 8.222 8.222 0 0 1-2.657 1.772c-.99.41-2.014.614-3.071.614a7.775 7.775 0 0 1-3.036-.607 8.047 8.047 0 0 1-2.6-1.757A7.846 7.846 0 0 1 0 8c0-1.057.202-2.074.607-3.05a8.033 8.033 0 0 1 1.764-2.62C3.895.777 5.766 0 7.985 0zm.03 1.443c-1.83 0-3.367.638-4.615 1.914a6.878 6.878 0 0 0-1.45 2.15A6.301 6.301 0 0 0 1.443 8c0 .858.168 1.684.507 2.479a6.627 6.627 0 0 0 1.45 2.129 6.593 6.593 0 0 0 2.129 1.428c.79.329 1.619.493 2.485.493.857 0 1.688-.166 2.494-.5a6.91 6.91 0 0 0 2.178-1.442c1.247-1.22 1.871-2.748 1.871-4.586a6.57 6.57 0 0 0-.486-2.515 6.397 6.397 0 0 0-1.413-2.114C11.37 2.086 9.824 1.443 8.014 1.443zm-.1 5.229-1.073.557c-.114-.238-.254-.405-.42-.5a.95.95 0 0 0-.465-.143c-.714 0-1.072.472-1.072 1.415 0 .428.09.77.271 1.028.181.257.448.386.8.386.467 0 .796-.229.987-.686l.985.5a2.35 2.35 0 0 1-2.1 1.257c-.714 0-1.29-.218-1.729-.657-.438-.438-.657-1.047-.657-1.828 0-.762.222-1.367.665-1.814.442-.448 1.002-.672 1.678-.672.991 0 1.7.385 2.13 1.157zm4.613 0-1.057.557c-.114-.238-.255-.405-.421-.5a.972.972 0 0 0-.479-.143c-.714 0-1.072.472-1.072 1.415 0 .428.091.77.272 1.028.18.257.447.386.8.386.466 0 .795-.229.985-.686l1 .5c-.218.39-.514.698-.885.922a2.308 2.308 0 0 1-1.214.335c-.724 0-1.302-.218-1.735-.657-.434-.438-.65-1.047-.65-1.828 0-.762.22-1.367.664-1.814.442-.448 1.002-.672 1.678-.672.99 0 1.696.385 2.114 1.157z"
        />
      </g>
    </svg>
  );
}
